import * as React from "react";
import { Box, Typography } from "@mui/material";
import type { DashboardSummary } from "../types/dashboard";
import NextDropCard from "./NextDropCard";
import ActivityCard from "./ActivityCard";

type Props = {
  data: DashboardSummary;
};

export default function RightRail({ data }: Props) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      <NextDropCard
        nextDropAt={data.nextDrop.nextDropAt}
        profileCompletionPercent={data.user.profileCompletionPercent}
      />
      <ActivityCard activity={data.activity} />

      {/* 팁 배너 */}
      <Box
        sx={{
          background: "linear-gradient(135deg, rgba(13,31,60,0.04), rgba(201,168,108,0.08))",
          border: "1px solid #D4BFA0",
          borderRadius: "14px",
          p: "18px",
        }}
      >
        <Typography sx={{ fontSize: "24px", mb: "8px" }}>💡</Typography>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 700, color: "#0D1F3C", mb: "6px" }}
        >
          매칭 팁
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#4A5A72", lineHeight: 1.6 }}>
          카드를 열람한 후 7일 이내에
          <br />
          대화를 시작하면 응답률이
          <br />
          2배 이상 높아집니다.
        </Typography>
      </Box>
    </Box>
  );
}
